// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line boundaries/element-types
import reducerPath from '../../../../app/reducerPath';
import checkStatus from '../../../../shared/http/checkStatus';
import HttpMethods from '../../../../shared/api/HttpMethods';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../../baseQueryWithReAuth/baseQueryWithReAuth';
import config from '../../../../shared/api/config';

export const adapterConfigsApi = createApi({
  reducerPath: `${reducerPath.adapterConfigsResource}/api`,
  tagTypes: ['TAG'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}`),

  endpoints: (builder) => ({
    getAdapterConfigs: builder.query({
      query: (params) => ({
        url: `/adapter-configs`,
        method: HttpMethods.GET,
        params,
        validateStatus: checkStatus,
      }),
    }),

    getAdapterConfigItems: builder.query({
      query: (params) => ({
        url: `/adapter-config-items`,
        method: HttpMethods.GET,
        params, // { "configId.equals": X }
        validateStatus: checkStatus,
      }),
    }),
  }),
});

export const { useGetAdapterConfigsQuery, useGetAdapterConfigItemsQuery } = adapterConfigsApi;
